/**
 * 哪些页面套学生端皮肤(2026-10-12 定:学生端 / 家长端用「深色外壳」shell,其余页面一律 default)。
 * 这里只放纯逻辑(范围规则、这一页套哪套、清掉样式试验台留在本机的记录),不碰 DOM、store 和路由对象;规则都有单元测试。
 *
 * 没有「选了哪套」这回事:套哪套只看页面。以后要做可选皮肤(机构白标、赛事换皮)时,在 skinForRoute 里加一层选择即可。
 */

/** 学生端 / 家长端页面用的皮肤;范围外的页面用的皮肤(都是 skins/ 注册表里的 id) */
export const STUDENT_SKIN = 'shell';
export const BASE_SKIN = 'default';

/** 判范围要用到的路由信息(vue-router 的 RouteLocation 满足这个形状) */
export interface SkinRoute {
  path: string;
  name?: unknown;
  meta?: Record<string, unknown>;
}

/**
 * 带 student 标记、但不跟学生端皮肤走的页面:「请用考试客户端」是对外页面那套样式(下载、说明,styles/public-kit.css)。
 * 考试端的检录页和答题页 2026-10-13 起也套深色外壳(从考试列表点进去不再变回旧样子;样式在 skins/shell/styles/exam.css)。
 */
const OWN_LOOK = new Set(['exam-use-client']);
/** 没带 student 标记、但属于学生端 / 家长端的入口页 */
const EXTRA_PATHS = ['/home', '/select-student'];
const EXTRA_PREFIXES = ['/parent', '/consent-setup'];

/**
 * 这一页在不在学生端皮肤的范围:路由带 student 标记的学生端页面(含考试端的检录、答题;「请用考试客户端」页、
 * ScratchJr 启蒙那几页除外),加上家长端(/parent…)、选学员、监护人同意设置、登录后的落地页(/home)。
 */
export function inStudentSkinScope(to: SkinRoute): boolean {
  const name = typeof to.name === 'string' ? to.name : '';
  // 启蒙(jr-*)是另一套全屏的儿童界面,有自己的美术;「请用考试客户端」是对外页面那套
  if (OWN_LOOK.has(name) || name.startsWith('jr-')) return false;
  if (to.meta?.['student'] === true) return true;
  const path = to.path;
  if (EXTRA_PATHS.includes(path)) return true;
  return EXTRA_PREFIXES.some((p) => path === p || path.startsWith(`${p}/`));
}

/** 这一页该套哪套皮肤:范围内 shell,范围外 default */
export function skinForRoute(to: SkinRoute): string {
  return inStudentSkinScope(to) ? STUDENT_SKIN : BASE_SKIN;
}

/** localStorage 的最小形状(隐私模式下可能整个拿不到,或者一碰就抛) */
export interface KvStore {
  removeItem(key: string): void;
}

/**
 * 样式试验台(2026-10-12 下线)在浏览器里留过的记录:试验开关、面板收起状态、选中的试验皮肤。
 * 现在没有任何代码读它们;启动时删一遍,免得一直躺在用户的本机存储里。
 */
export const STALE_LAB_KEYS = ['cg.skinlab', 'cg.skinlab.fold', 'cg.skin'] as const;

/** 一次性的小清理:本机存储拿不到、或者某一条删不掉都不报错,也不挡后面几条 */
export function clearStaleLabKeys(store: KvStore | null | undefined): void {
  for (const key of STALE_LAB_KEYS) {
    try {
      store?.removeItem(key);
    } catch {
      /* 隐私模式:删不了就留着,反正没人读 */
    }
  }
}
